const riot = require('riot');

riot.tag2('page-debug', '<div class="container"> <div class="p32"> <h1 class="mb32">Typography</h1> <div class="mb32"> <h3 class="mb8">Heading</h3> <div class="ts-hl">Heading / l</div> <div class="ts-hm">Heading / m</div> <div class="ts-hs">Heading / s</div> <div class="ts-hxs">Heading / xs</div> <div class="ts-hxxs">Heading / xxs</div> </div> <div class="mb32"> <h3 class="mb8">Paragraph </h3> <div class="ts-pm">Paragraph / m</div> <div class="ts-ps">Paragraph / s</div> <div class="ts-pxs">Paragraph / xs</div> </div> <div class="mb32"> <h3 class="mb8">Button </h3> <div class="ts-bm">Button / m</div> <div class="ts-bs">Button / s </div> </div> <div class="mb32"> <h3 class="mb8">Table</h3> <div class="ts-table-td">Table / td </div> <div class="ts-table-th">Table / th </div> </div> </div> <div class="p32"> <h1 class="mb32">Elevation</h1> <div class="row mb32"> <div class="f fh s140 elevation-default-high mr16">Default high</div> <div class="f fh s140 elevation-default-mid mr16">Default mid</div> <div class="f fh s140 elevation-default-low">Default low</div> </div> <div class="row mb32"> <div class="f fh s140 elevation-blue-high mr16">Blue high</div> <div class="f fh s140 elevation-blue-mid mr16">Blue mid</div> <div class="f fh s140 elevation-blue-low">Blue low</div> </div> <div class="row mb32"> <div class="f fh s140 elevation-caution-high mr16">Caution high</div> <div class="f fh s140 elevation-caution-mid mr16">Caution mid</div> <div class="f fh s140 elevation-caution-low">Caution low</div> </div> <div class="row mb32"> <div class="f fh s140 elevation-primary-high mr16">Primary high</div> <div class="f fh s140 elevation-primary-mid mr16">Primary mid</div> <div class="f fh s140 elevation-primary-low">Primary low</div> </div> </div> <div class="p32"> <h1 class="mb32">Color</h1> <div class="row mb32"> <div class="f fh s140 bg-gray_80 mr16">gray_80</div> <div class="f fh s140 bg-gray_60 mr16">gray_60</div> <div class="f fh s140 bg-gray_30 mr16">gray_30</div> <div class="f fh s140 bg-gray_20 mr16">gray_20</div> <div class="f fh s140 bg-gray_10 mr16">gray_10</div> <div class="f fh s140 bg-gray_05 mr16">gray_05</div> <div class="f fh s140 bg-white">white</div> </div> <div class="row mb32"> <div class="f fh s140 bg-navy mr16">navy</div> <div class="f fh s140 bg-navy_30 mr16">navy_30</div> <div class="f fh s140 bg-navy_05">navy_05</div> </div> <div class="row mb32"> <div class="f fh s140 bg-pink_70 mr16">pink_70</div> <div class="f fh s140 bg-pink_50 mr16">pink_50</div> <div class="f fh s140 bg-pink_40 mr16">pink_40</div> <div class="f fh s140 bg-pink_05">pink_05</div> </div> <div class="row mb32"> <div class="f fh s140 bg-primary mr16">primary</div> <div class="f fh s140 bg-primary_weak">primary_weak</div> </div> <div class="row mb32"> <div class="f fh s140 bg-blue mr16">blue</div> <div class="f fh s140 bg-blue_90 mr16">blue_90</div> <div class="f fh s140 bg-blue_70 mr16">blue_70</div> <div class="f fh s140 bg-blue_60 mr16">blue_60</div> <div class="f fh s140 bg-blue_05">blue_05</div> </div> <div class="row mb32"> <div class="f fh s140 bg-yellow mr16">yellow</div> <div class="f fh s140 bg-yellow_90 mr16">yellow_90</div> <div class="f fh s140 bg-yellow_80 mr16">yellow_80</div> <div class="f fh s140 bg-yellow_60 mr16">yellow_60</div> <div class="f fh s140 bg-yellow_05">yellow_05</div> </div> <div class="row mb32"> <div class="f fh s140 bg-red mr16">red</div> <div class="f fh s140 bg-red_90 mr16">red_90</div> <div class="f fh s140 bg-red_70 mr16">red_70</div> <div class="f fh s140 bg-red_05">red_05</div> </div> <div class="row mb32"> <div class="f fh s140 bg-green_90 mr16">green_90</div> <div class="f fh s140 bg-green_70 mr16">green_70</div> <div class="f fh s140 bg-green_60 mr16">green_60</div> <div class="f fh s140 bg-green_40 mr16">green_40</div> <div class="f fh s140 bg-green_05 mr16">green_05</div> </div> <div class="row mb32"> <div class="f fh s140 bg-purple_90">purple_90</div> </div> <div class="row mb32"> <div class="f fh s140 bg-grad_pink mr16">grad_pink</div> <div class="f fh s140 bg-grad_blue mr16">grad_blue</div> <div class="f fh s140 bg-grad_light_blue">grad_light_blue</div> </div> <div class="row mb32"> <div class="f fh s140 hover-trigger hover-bg-grad_pink mr16">hover-grad_pink</div> <div class="f fh s140 hover-trigger hover-bg-grad_primary mr16">hover-grad_primary</div> <div class="f fh s140 hover-trigger hover-bg-navy mr16">hover-navy</div> <div class="f fh s140 hover-trigger hover-bg-gray_05 mr16">hover-gray_05</div> <div class="f fh s140 hover-trigger hover-bg-navy_05 mr16">hover-navy_05</div> <div class="f fh s140 hover-trigger hover-bg-red_05">hover-red_05</div> </div> </div> <div class="p32"> <h1 class="mb32">input</h1> <div class="mb16"> <div class="mb16">error</div> <input class="input w400 mb8" placeholder="アドレスを入力してください" type="email"> <input class="input size-s w400 mb8" placeholder="アドレスを入力してください" type="email"> <input class="input size-xs w400 mb8" placeholder="アドレスを入力してください" type="email"> <textarea class="textarea w400" rows="5" minlength="3" placeholder="3文字以上入力してください"></textarea> </div> <div class="mb16"> <div class="mb16">disabled</div> <input class="input w400 mb8" placeholder="プレイスホルダー" disabled> <input class="input size-s w400 mb8" placeholder="プレイスホルダー" disabled> <input class="input size-xs w400 mb8" placeholder="プレイスホルダー" disabled> <textarea class="textarea w400" rows="5" placeholder="プレイスホルダー" disabled></textarea> </div> <div class="mb16"> <div class="mb16">readonly</div> <input class="input w400 mb8" value="読み取り専用" readonly> <input class="input size-s w400 mb8" value="読み取り専用" readonly> <input class="input size-xs w400 mb8" value="読み取り専用" readonly> <textarea class="textarea w400" rows="5" placeholder="読み取り専用" readonly></textarea> </div> </div> <div class="p32"> <h1 class="mb32">select</h1> <h2 class="mb12">checkbox</h2> <div class="f fm mb24"> <input class="checkbox mr12" type="checkbox"> <input class="checkbox mr12" type="checkbox" disabled> <input class="checkbox mr12" type="checkbox" disabled checked> <input class="checkbox" ref="indeterminate" type="checkbox"> </div> <h2 class="mb12">radio</h2> <div class="f fm mb24"> <input class="radio mr12" type="radio" name="radio"> <input class="radio mr12" type="radio" name="radio"> <input class="radio mr12" type="radio" name="radio" disabled> <input class="radio mr12" type="radio" name="checked_disabled" disabled checked> </div> <h2 class="mb12">switch</h2> <div class="f fm mb24"> <input class="switch mr12" type="checkbox"> <input class="switch mr12" type="checkbox" disabled> <input class="switch mr12" type="checkbox" disabled checked> </div> <h2 class="mb12">select</h2> <div class="f fm w400 mb12" data-is="atom-input-select" options="{app.data.constants.point_deposit_history_deal_types}" placeholder="placeholder"></div> <div class="f fm w400 mb12" data-is="atom-input-select" options="{app.data.constants.point_deposit_history_deal_types}" placeholder="disabled" disabled></div> </div> <div class="p32"> <h1 class="mb32">table</h1> <div class="mb32" data-is="module-table" schemas="{tableSchemas}" items="{items}" get-href="{getHref}" scroll-type="x"></div> <div data-is="module-table" schemas="{distributionRulesTableSchemas}" items="{distributionRules}" scroll-type="x"></div> </div> <div class="p32"> <h1 class="mb32">button</h1> <h2 class="mb12">primary</h2> <div class="f mb24"> <div class="mr8"> <div class="mb4">size-l</div> <button class="button primary size-l">ボタン</button> </div> <div class="mr8"> <div class="mb4">size-m</div> <button class="button primary size-m">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">size-s</div> <button class="button primary"><i class="icon-arrow_left fs20 mr4"> </i> <div>小さなボタン</div> </button> </div> <div class="mr8"> <div class="mb4">size-xs</div> <button class="button primary size-xs">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">shadow-mid</div> <button class="button primary size-xs shadow-mid">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">disabled</div> <button class="button primary size-xs disabled">小さなボタン</button> </div> </div> <h2 class="mb12">secondary</h2> <div class="f mb24"> <div class="mr8"> <div class="mb4">size-l</div> <button class="button secondary size-l">ボタン</button> </div> <div class="mr8"> <div class="mb4">size-m</div> <button class="button secondary size-m">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">size-s</div> <button class="button secondary">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">size-xs</div> <button class="button secondary size-xs">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">disabled</div> <button class="button secondary size-xs" disabled>小さなボタン</button> </div> </div> <h2 class="mb12">outline</h2> <div class="f mb24"> <div class="mr8"> <div class="mb4">size-l</div> <button class="button size-l">ボタン</button> </div> <div class="mr8"> <div class="mb4">size-m</div> <button class="button size-m">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">size-s</div> <button class="button">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">size-xs</div> <button class="button size-xs">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">disabled</div> <button class="button size-xs disabled">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">icon</div> <button class="button size-xs w28"><i class="icon-arrow_left fs20"></i></button> </div> </div> <h2 class="mb12">danger</h2> <div class="f mb24"> <div class="mr8"> <div class="mb4">size-l</div> <button class="button danger size-l">ボタン</button> </div> <div class="mr8"> <div class="mb4">size-m</div> <button class="button danger size-m">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">size-s</div> <button class="button danger">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">size-xs</div> <button class="button danger size-xs">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">disabled</div> <button class="button danger size-xs disabled">小さなボタン</button> </div> </div> <h2 class="mb12">text</h2> <div class="f mb24"> <div class="mr8"> <div class="mb4">size-l</div> <button class="button text size-l">ボタン</button> </div> <div class="mr8"> <div class="mb4">size-m</div> <button class="button text size-m">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">size-s</div> <button class="button text">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">size-xs</div> <button class="button text size-xs">小さなボタン</button> </div> <div class="mr8"> <div class="mb4">disabled</div> <button class="button text size-xs disabled">小さなボタン</button> </div> </div> </div> <div class="p32"> <h1 class="mb32">Dialog</h1> <div class="mb24"> <h2 class="mb12">size</h2> <div class="f fm"> <label class="f fm mr12"> <input class="radio mr4" ref="dialog_checkbox" type="radio" name="size" value="large"> <div>large</div> </label> <label class="f fm mr12"> <input class="radio mr4" ref="dialog_checkbox" type="radio" name="size" value="medium"> <div>medium</div> </label> <label class="f fm mr12"> <input class="radio mr4" ref="dialog_checkbox" type="radio" name="size" value="small"> <div>small</div> </label> </div> </div> <div class="mb24"> <h2 class="mb12">danger</h2> <input class="checkbox" ref="dialog_danger" type="checkbox"> </div> <di class="mb24"> <h2 class="mb12">title</h2> <input class="input" ref="dialog_title"> </di> <div class="mb24"> <h2 class="mb12">text</h2> <input class="input" ref="dialog_text"> </div> <div class="mb24"> <h2 class="mb12">negative_button_type</h2> <div class="f fm"> <label class="f fm mr12"> <input class="radio mr4" ref="dialog_negative_button_type" type="radio" name="negative_button_type" value="primary"> <div>primary</div> </label> <label class="f fm mr12"> <input class="radio mr4" ref="dialog_negative_button_type" type="radio" name="negative_button_type" value="secondary"> <div>secondary</div> </label> <label class="f fm mr12"> <input class="radio mr4" ref="dialog_negative_button_type" type="radio" name="negative_button_type" value="text"> <div>text</div> </label> </div> </div> <div class="mb24"> <h2 class="mb12">positive_button_type</h2> <div class="f fm"> <label class="f fm mr12"> <input class="radio mr4" ref="dialog_positive_button_type" type="radio" name="positive_button_type" value="primary"> <div>primary</div> </label> <label class="f fm mr12"> <input class="radio mr4" ref="dialog_positive_button_type" type="radio" name="positive_button_type" value="secondary"> <div>secondary</div> </label> <label class="f fm mr12"> <input class="radio mr4" ref="dialog_positive_button_type" type="radio" name="positive_button_type" value="text"> <div>text</div> </label> </div> </div> <button class="button primary" onclick="{openDialog}">open dialog</button> </div> <div class="p32"> <h1 class="mb32">Badge</h1> <div> <div class="mb24"> <h2 class="mb12">distribution_rule_statusesのバッジ</h2> <div class="mr8 mr0-last" each="{item in dummyDistributionRuleData}" data-is="atom-distribution_rule_status-badge" item="{item}"></div> </div> <div class="mb24"> <h2 class="mb12">distribution_rule_statusesのバッジ</h2> <div class="mr8 mr0-last" each="{item in dummyDistributionJobData}" data-is="atom-distribution_event_csv_job_status-badge" item="{item}"></div> </div> <div class="mb24"> <h2 class="mb12">onetime_hash_csv_job_statusesのバッジ</h2> <div class="mr8 mr0-last" each="{item in dummyOneTimeHashData}" data-is="atom-onetime_hash_csv_job_status-badge" item="{item}"></div> </div> </div> </div> <div class="p32"> <h1 class="mb32">Section</h1> <form class="rounded-8 elevation-default-low mb24" onsubmit="{onSubmitSection}"> <div class="section-padding"> <div data-is="module-section-header" title="セクションタイトル" description="説明文"> <yield to="right"> <div class="button primary">button</div> </yield> </div> </div> <div data-is="module-section-footer" buttons="{buttons}"></div> </form> <form class="rounded-8 elevation-default-low" onsubmit="{onSubmitSection}"> <div class="section-padding"> <div data-is="module-section-header" title="セクションタイトル2" description="説明文2"> <yield to="right"> <div class="button primary">text</div> </yield> </div> </div> <div data-is="module-section-footer" buttons="{[buttons[1]]}"></div> </form> </div> <div class="p32"> <h1 class="mb32">PageHeader</h1> <div class="mb24" data-is="module-page-header" back="/" title="ページタイトル" breadcrumbs="{breadcrumbs}"> <yield to="badge"> <div data-is="atom-distribution_event_csv_job_status-badge" item="{parent.dummyDistributionJobData[0]}"></div> </yield> <yield to="right"> <div class="button primary">新規作成</div> </yield> </div> <div class="mb24" data-is="module-page-header" back="{true}" title="ページタイトル" breadcrumbs="{breadcrumbs}"> <yield to="badge"> <div data-is="atom-distribution_event_csv_job_status-badge" item="{parent.dummyDistributionJobData[1]}"></div> </yield> <yield to="right"> <div class="button primary">新規作成</div> </yield> </div> <div class="mb24" data-is="module-page-header" title="ページタイトル" breadcrumbs="{breadcrumbs}"> <yield to="badge"> <div data-is="atom-distribution_event_csv_job_status-badge" item="{parent.dummyDistributionJobData[1]}"></div> </yield> <yield to="right"> <div class="button">保存</div> </yield> </div> <div class="mb24" data-is="module-page-header" title="ページタイトル"></div> </div> <div class="p32"> <h1 class="mb32">debug用抽選配布ルール作成</h1> <button class="button primary size-l" onclick="{onCreateLottery}">新規作成</button> </div> <div class="p32"> <h1 class="mb32">抽選配分 (新規作成)</h1> <form class="mb16" onsubmit="{getOnRafflePatternSubmit(&quot;newRafflePatterns&quot;)}"> <div data-is="atom-input-raffle-patterns" ref="newRafflePatterns" heading="抽選配分"></div> <button class="button mb32">console.log</button> </form> <h1 class="mb32">抽選配分 (編集)</h1> <form class="mb16" onsubmit="{getOnRafflePatternSubmit(&quot;editRafflePatterns&quot;)}"> <div data-is="atom-input-raffle-patterns" patterns="{dummyRaffleResultPatterns}" is-edit="{true}" ref="editRafflePatterns" heading="抽選設定と発行済み金額"></div> <button class="button mb32">console.log</button> </form> </div> <div class="p32"> <h1 class="mb32">atom-tabs</h1> <div class="mb24" ref="tabs" data-is="atom-tabs" items="{tabs}" scroll="{false}"></div> <div>currentTabId: {refs.tabs.current}</div> </div> </div>', 'page-debug,[data-is="page-debug"]{display:block}', '', function(opts) {

    this.tabs = [
      {
        id: 'raffle',
        label: '抽選画面',
      },
      {
        id: 'raffle_result1',
        label: '抽選画面1',
      },
      {
        id: 'raffle_result2',
        label: '抽選画面2',
      },
      {
        id: 'lost',
        label: 'ハズレ',
      },
    ];

    this.preload = ({req, res}) => {
      if (!spat.isBrowser) return ;

      if (spat.config.env === 'production') {
        throw { status: 404 };
        return ;
      }
    };

    this.on('mount', () => {
      var $checkbox = this.refs.indeterminate;
      $checkbox.indeterminate = true;
      this.update();

      this.refs.tabs.on('change', ({current}) => {
        console.log(current);
        this.update();
      });
    });

    this.on('show', () => {

      this.refs.tabs.setCurrent('raffle');
    });

    this.onSubmitSection = (e) => {
      e.preventDefault();
      spat.modal.alert('送信');
    };

    this.openDialog = async () => {
      var $size = this.refs.dialog_checkbox.find(c => c.checked);
      var size = $size ? $size.value : '';

      var $negative_button_type = this.refs.dialog_negative_button_type.find(b => b.checked);
      var negative_button_type = $negative_button_type ? $negative_button_type.value : '';

      var $positive_button_type = this.refs.dialog_positive_button_type.find(b => b.checked);
      var positive_button_type = $positive_button_type ? $positive_button_type.value : '';

      var query = {
        title: this.refs.dialog_title.value,
        text: this.refs.dialog_text.value,
        danger: this.refs.dialog_danger.checked,
        size,
        negative_button_type,
        positive_button_type,
      };
      var result = await app.utils.openModalDialog(query);
      if (!result) return;
      spat.modal.alert('positive event');
    };

    this.tableSchemas = [
      {
        id: 'apply_at',
        label: '反映日',
        class: 'w132 flex-fixed',
        getText: (v) => dayjs(v).format('YYYY-MM-DD'),
      },
      {
        id: 'amount',
        label: '金額(円)',
        class: 'w110 flex-fixed',
        align: 'right',
        getText: (v, h) => h.deal_type === 'refund' ? `-${v.toLocaleString()}` : v.toLocaleString(),
      },
      {
        id: 'reason',
        label: 'コメント',
        class: 'min-width-200 w0 flex-auto',
      },

      {
        id: 'menu',
        component: 'material-icon-button',
        text: 'more_vert',
        align: 'center',
        class: 'flex-fixed w52',
        onclick: (history, e) => {
          this.openPopup(history, e);
        },
      },
    ];

    this.getHref = (item) => {
      return item.id === 'c8eanki23akg00e1th6g' ? '/admin/companies' : null;
    };

    this.createDistributionRule = ({
      id = 'c8k4apq23akg00e3v2hg',
      name = '配布ルール',
      archived_at = 0,
      status = 'in_review',
    } = {}) => {
      return {
        id,
        name,
        status,
        archived_at,
        updated_at: 1647401292281,
      };
    };

    this.items = [
      {
        "id": "c87plpq23akg00eeq1t0",
        "deal_type": "deposit",
        "amount": 111111,
        "apply_at": 1643814000000,
        "reason": "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
        "created_at": 1645189863436,
        "updated_at": 1645236354685
      },
      {
        "id": "c8855fi23akg00d82sg0",
        "deal_type": "deposit",
        "amount": 999999999,
        "apply_at": 1645196400000,
        "reason": "test 入金",
        "created_at": 1645236926028,
        "updated_at": 1645236926028
      },
      {
        "id": "c8eaidq23akg00e1th60",
        "deal_type": "refund",
        "amount": 333333,
        "apply_at": 1645974000000,
        "reason": "debug",
        "created_at": 1646045495530,
        "updated_at": 1646045495530
      },
      {
        "id": "c8eanki23akg00e1th6g",
        "deal_type": "refund",
        "amount": 999999999,
        "apply_at": 1645974000000,
        "reason": "遷移可能",
        "created_at": 1646046162883,
        "updated_at": 1646046162883
      }
    ];

    this.distributionRulesTableSchemas = [
      {
        id: 'updated_at',
        label: '更新日時',
        class: 'w132 flex-fixed',
        getText: (v) => dayjs(v).format('YYYY-MM-DD'),
      },
      {
        id: 'status',
        label: 'ステータス',
        align: 'center',
        class: 'w132 flex-fixed',
        component: 'distribution_rule_status-badge',
      },
      {
        id: 'name',
        label: '配布ルール名',
        class: 'min-width-200 w0 flex-auto',
      },
    ];

    this.distributionRules = [
      this.createDistributionRule({ name: 'アーカイブ', archived_at: 1 }),
      this.createDistributionRule({ name: '審査中' }),
      this.createDistributionRule({ name: '公開', status: 'published' }),
      this.createDistributionRule({ name: '下書き', status: 'draft' }),
    ];

    this.openPopup = (history, e) => {
      e.preventDefault();
      e.stopPropagation();
      var options = [
        {
          icon: "pencil",
          label: "入金履歴の編集",
          action: () => {
            popup.close();
          },
        },
        {
          icon: "trash",
          label: "削除",
          alert: true,
          action: () => {
            popup.close();
          },
        },
      ];
      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 8,
        position: 'bottom',
        align: {x: 'right'},
        opts: {
          options,
        }
      });
    };

    this.onAlert = (item ,e) => {
      window.alert('onclick');
      console.log(item, e);
    };

    this.dummyDistributionRuleData = [
      {
        status: 'published',
        archived_at: 1647401292281,
      },
      {
        status: 'published',
        archived_at: 0,
      },
      {
        status: 'draft',
        archived_at: 0,
      },
      {
        status: 'in_review',
        archived_at: 0,
      },
    ];

    this.dummyDistributionJobData = [
      { status: 'failed' }, {status: 'complete'}, {status: 'in_progress'},
    ];

    this.dummyOneTimeHashData = [
      { status: 'failure' }, {status: 'complete'}, {status: 'in_progress'},
    ];

    this.breadcrumbs = [
      {
        link: '/',
        label: '第一階層',
      },
      {
        link: '/',
        label: '第二階層',
      },
    ];

    this.buttons = [
      {
        type: 'button',
        text: '削除',
        class: 'danger',
        onclick: () => spat.modal.alert('削除'),
      },
      {
        type: 'submit',
        text: '保存',
        class: '',
      },
    ];

    this.onCreateLottery = async () => {
      var indicator = spat.modal.indicator();
      var env = spat.config.env;

      if (env === 'development') {
        var company_id = 'c95ai5a23akg00ceab0g';
        var project_id = 'c95ao0q23akg00ceab20';
        var campaign_id = 'c95ao7i23akg00ceab30';
      }
      else if (env === 'staging') {
        var company_id = 'c5vju24bcv4283r1raa0';
        var project_id = 'cb8d6fi23akg0097svs0';
        var campaign_id = 'cb8d6lq23akg0097svsg';
      }

      var query = {
        archive_at: 1647999954651,
        assets: [
          {
            content_type: "image/jpeg",
            name: "ほげほげ",
            path: `c7ghdea23akg00dpjen0dddc${dayjs().unix()}.jpeg`,
          }
        ],
        campaign_id: campaign_id,
        distribution_target_type: "raffle",
        name: `debug用抽選配布ルール ${dayjs().format('YYYY/MM/DD HH:mm:ss')}`,
        point_provider: "paypay",
        raffle_result_patterns: [
          {
            amount: 100,
            description: "ほげほげ1",
            image_path: "c7ghdea23akg00dpjen0dddc.jpeg",
            is_fallback: false,
            max_lot: 10,
            weight: 10
          },
          {
            amount: 10,
            description: "ほげほげ2",
            image_path: "c7ghdea23akg00dpjen0dddc.jpeg",
            is_fallback: false,
            max_lot: 90,
            weight: 20
          },
          {
            amount: 0,
            description: "ほげほげ3",
            image_path: "c7ghdea23akg00dpjen0dddc.jpeg",
            is_fallback: false,
            max_lot: 100,
            weight: 70
          }
        ],
        raffle_rule: {
          button_text: "ぼたん",
          close_at: 1658389813400,
          description: "ほげほげ",
          image_path: "c7ghdea23akg00dpjen0dddc.jpeg"
        },
        review_reason: "aaaaaa",
        status: "draft",
        thumbnail_asset_id: "c68tfssbcv41qooqd721",
      };

      try {
        var { distribution_rule } = await app.api.child(`companies/${company_id}/projects/${project_id}/distribution_rules`).post(query);
        spat.modal.alert('作成しました');
        spat.router.push(`/app/companies/${company_id}/projects/${project_id}/campaigns/${campaign_id}/distribution_rules/${distribution_rule.id}`);
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    const BASE_WEIGHT = 100000000;
    this.dummyRaffleResultPatterns = [
      {
        amount: 100,
        description: "ほげほげ1",
        image_path: "c7ghdea23akg00dpjen0dddc.jpeg",
        is_fallback: false,
        max_lot: 10,
        weight: (1 / 100) * BASE_WEIGHT,
      },
      {
        amount: 10,
        description: "ほげほげ2",
        image_path: "c7ghdea23akg00dpjen0dddc.jpeg",
        is_fallback: false,
        max_lot: 90,
        weight: (0.1 / 100) * BASE_WEIGHT,
      },
      {
        amount: 0,
        description: "ハズレ",
        image_path: "c7ghdea23akg00dpjen0dddc.jpeg",
        is_fallback: true,
        max_lot: 100,

        weight: 0,
      }
    ];

    this.getOnRafflePatternSubmit = (name) => {
      return (e) => {
        e.preventDefault();
        console.log(this.refs[name].getValue());
      };
    };
});